import styled from "styled-components";

interface Props {
    children: React.ReactNode;
    onClick?: () => void;
    className?: string;
    style?: React.CSSProperties;
    disabled?: boolean;
    type?: 'default' | 'red' | 'primary';
}

const Container = styled.div`

    .button {
        background-color: var(--content-box-border, #0074d9);
    }
    
    .red {
        background-color: var(--error-red, #ff0000);
    }
    
    .primary {
        background-color: var(--secondary-blue, #0074d9);
    }
`;

const ButtonContainer = styled.button`
    color: #fff;
    border: none;
    padding: 0.25rem .5rem;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: var(--primary-blue-hover, #005bb5);
    }

    &:disabled {
        background-color: var(--disabled-gray, #ccc);
        cursor: not-allowed;
    }
`;

export default function Button({children, onClick, className, style, disabled, type}: Props) {
    return (
        <Container className={type ? ' ' + type : ''}>
            <ButtonContainer
                onClick={onClick}
                className={className+' button'}
                style={style}
                disabled={disabled}
            >
                {children}
            </ButtonContainer>
        </Container>
    );
}

